import {useContext} from "react";
import {MapContext} from "../context/MapContext";
import {Add, MusicNote} from "reicon-react";
import {motion, useReducedMotion} from "motion/react";
import {markerIcons} from './markerIcons';
import {simulatedPosition} from "../data/current-location";

const toRadians = value => value * Math.PI / 180

const getDistanceInMeters = ([latitude, longitude]) => {
  const [currentLatitude, currentLongitude] = simulatedPosition
  const latitudeDifference = toRadians(latitude - currentLatitude)
  const longitudeDifference = toRadians(longitude - currentLongitude)
  const calculation =
    Math.sin(latitudeDifference / 2) ** 2 +
    Math.cos(toRadians(currentLatitude)) * Math.cos(toRadians(latitude)) *
    Math.sin(longitudeDifference / 2) ** 2

  return 6371000 * 2 * Math.atan2(Math.sqrt(calculation), Math.sqrt(1 - calculation))
}

const formatDistance = coordinates => {
  const distance = Math.min(...coordinates.map(getDistanceInMeters))

  if (distance >= 1000) return `${(distance / 1000).toFixed(1)} km`
  return `${Math.max(10, Math.round(distance / 10) * 10)} m`
}

const LocationListItem = ({item}) => {
  const {featuredMarker, setFeaturedMarker, setMapFocus, setPanelStatus, setRouteTarget} = useContext(MapContext)
  const isFeaturedItem = featuredMarker === item
  const Icon = markerIcons[item?.name] || MusicNote
  const prefersReducedMotion = useReducedMotion()
  const locationsCount = item?.coords?.length ?? 0
  const distance = formatDistance(item.coords)

  const selectMarker = () => {
    setFeaturedMarker(item)
    setMapFocus({coords: item.coords, id: `${item.type}-${item.index}-${Date.now()}`})
    setRouteTarget(item.coords.length === 1 ? item.coords[0] : null)
    setPanelStatus('close')
  }

  const unselectMarker = () => {
    setFeaturedMarker(null)
    setRouteTarget(null)
    setMapFocus({reset: true, id: `initial-view-${Date.now()}`})
    setPanelStatus('open')
  }

  return (
    <motion.li
      className={`location-list-item ${isFeaturedItem ? 'featured' : ''}`}
      style={{'--color': item?.color}}
      layout="position"
      initial={prefersReducedMotion ? false : {opacity: 0, scale: 0.96}}
      animate={{opacity: 1, scale: 1}}
      exit={prefersReducedMotion ? {opacity: 0} : {opacity: 0, scale: 0.92}}
      transition={{duration: prefersReducedMotion ? 0 : 0.18, ease: 'easeOut'}}>
      <button className="item-content" type="button" onClick={selectMarker}>
        <span className="circle" aria-hidden="true">
          <Icon size={22} weight="Filled" />
        </span>
        <span className="text">
          <span className="name">{item?.name}</span>
          <span className="description">
            {distance}
            {locationsCount > 1 && <><span aria-hidden="true"> • </span>{locationsCount} ubicaciones</>}
          </span>
        </span>
      </button>
      <button className="button-close"
        type="button"
        aria-label={`Deseleccionar ${item?.name}`}
        onClick={unselectMarker}>
        <Add className="close-icon" size={26} strokeWidth={2}/>
      </button>
    </motion.li>
  );
};

export default LocationListItem;
